<template>
  <div>
    <section id="landscape" style="display: none;">
      <img class="phone" src="../../../ui/20201111king_double_eleven/assets/phone.png">
      <p class="desc">为了更好的体验，请将手机竖过来</p>
    </section>

    <ZoneRole :state="state" :send="send"></ZoneRole>
    <BusyDialog :state="state" :send="send"></BusyDialog>

    <Main :state="state" :send="send"></Main>
    <!-- 活动入口 -->
    <a class="active-enter" href="javascript: void(0)" @click="send('SHOW_NOW_LIVE')">
      <img src="../../../ui/20201111king_double_eleven/assets/active-enter.gif" alt="" />
    </a>

    <Rule :state="state" :send="send"></Rule>

    <Toast v-if="state.toStrings().some(item=>item.indexOf('toast')>-1)"
           :toast-msg="state.context.error.message || state.context.toastMsg"></Toast>
    <Toast v-if="showToast" :toast-msg="getAggregatingMeta.message" ></Toast>
    <Award :state="state" :send="send"></Award>

    <activity-intro :state="state" :send="send"></activity-intro>

    <ErrorPage :state="state" :send="send"></ErrorPage>
    <AlertDialog :state="state" :send="send"></AlertDialog>

    <AwardList :state="state" :send="send"></AwardList>

    <Dialog :state="state" :send="send"></Dialog>

    <!-- 奖品列表 -->
    <PrizeList :state="state" :send="send"></PrizeList>

    <login-prompt url="https://pay.qq.com/h5/activity/bargain/wzry-20201111.php?pf=__mds_browser" :offer-id="state.context.gameConfig.offerId" v-if="state.matches('loginPrompt')"></login-prompt>

    <ShareDialog :state="state"></ShareDialog>

    <Now :state="state" :send="send"></Now>

    <PayDialog :state="state" :send="send"></PayDialog>
  </div>
</template>

<script>
import "../../../ui/20201111king_double_eleven/css/style.min.css"
import { useMachine } from "@xstate/vue"
import { computed, onMounted } from "@vue/composition-api"
import { appMachine } from "./statemachine/appmachine"
import Toast from "../common/components/Toast.vue"
import ZoneRole from "./components/ZoneRole.vue"
import Main from "./components/Main.vue"
import BusyDialog from "./components/BusyDialog.vue"
import Rule from "./components/Rule.vue"
import Award from "./components/Award.vue"
import ActivityIntro from "./components/ActivityIntro.vue"
import ErrorPage from "./components/ErrorPage.vue"
import AlertDialog from "./components/AlertDialog.vue"
import AwardList from "./components/AwardList.vue"
import PrizeList from "./components/PrizeList.vue"
import LoginPrompt from "../common/components/LoginPrompt.vue"
import ShareDialog from "./components/ShareDialog.vue"
import Dialog from "./components/Dialog.vue"
import PayDialog from "./components/PayDialog.vue"
import * as userBusiness from "./business/user"
import * as request from "../common/utils/request"
import * as userAgent from "../common/utils/ua"
import * as configs from "./configs"
import Now from "./components/Now.vue"

export default {
  name: "App.vue",
  components: {
    Award,
    Toast,
    ZoneRole,
    Main,
    BusyDialog,
    Rule,
    ActivityIntro,
    ErrorPage,
    AwardList,
    PrizeList,
    AlertDialog,
    Dialog,
    LoginPrompt,
    ShareDialog,
    Now,
    PayDialog
  },
  setup() {
    const { state, send, service } = useMachine(appMachine)
    if (process.env.NODE_ENV === "development") {
      service.onTransition(state => {
        console.log(state)
      })
    }

    // const body = document.querySelector("body")
    // if (state.value.context.userAgent.msdk) {
    //   body.classList.add("mini")
    // }
    const showToast = computed(() => {
      return [
        "participate.pay.preCheck.failure.visible",
        "participate.pay.placeOrder.failure.visible",
        "participate.luckydraw.batchDraw.autoOpenBoxToast.visible",
        // "participate.luckydraw.batchDraw.getAllTaskPresent.failure.visible",
        // "participate.luckydraw.batchDraw.getAllLuckCoupon.failure.visible",
        "participate.luckydraw.showDrawDialog.receiveTaskPresent.failure.visible",
        "participate.luckydraw.showDrawDialog.getDrawCoupon.failure.visible",
        "participate.luckydraw.showDrawDialog.drawPresent.failure.visible",
        "participate.pay.payment.autoDraw.visible",
        "participate.pay.forbidden.toast"
      ].some(state.value.matches)
    })

    const mergeMeta = meta => {
      return Object.keys(meta).reduce((acc, key) => {
        const value = meta[key]

        // Assuming each meta value is an object
        Object.assign(acc, value)

        return acc
      }, {})
    }
    const getAggregatingMeta = computed(() => {
      return mergeMeta(state.value.meta)
    })

    onMounted(() => {
      // 初始化分享
      let sharePf
      let ua = userAgent.getUserAgent()

      if (ua.QQ) {
        sharePf = "__mds_qq_share"
      } else if (ua.weixin) {
        sharePf = "__mds_wx_share"
      }

      userBusiness.setOnShareHandler({
        userAgent: ua,
        shareInfo: configs.GAME_INFO.shareInfo,
        url: `${configs.GAME_INFO.shareInfo.URL}?${request.serializeParams({
          pf: sharePf
        })}`
      })
    })

    return {
      state,
      send,
      showToast,
      getAggregatingMeta
    }
  }
}
</script>

<style scoped>
</style>
